import { render, staticRenderFns } from "./index.vue?vue&type=template&id=dcd8cba2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd8cba2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dcd8cba2')) {
      api.createRecord('dcd8cba2', component.options)
    } else {
      api.reload('dcd8cba2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=dcd8cba2&scoped=true", function () {
      api.rerender('dcd8cba2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/organization/index.vue"
export default component.exports